module.exports = __webpack_public_path__ + "media/images/views/lp/client/client-logo/bainisys-6c70c889fb041cd2a708f35fd0bec5cf.png";